import React, {Fragment} from 'react';
import Select, {components} from 'react-select';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';
import _ from 'lodash';
import InputWrap from "./InputWrap";
import Collapsible from "react-collapsible";
import {collapsibleSettings} from "../../helpers/Helpers";

const SingleValue = ({children, ...props}) => {
    if (props.selectProps.menuIsOpen) {
        return (
            <components.SingleValue {...props}/>
        );
    } else {
        return (
            <components.SingleValue {...props}>
                {children}
            </components.SingleValue>
        );
    }
};

const Option = props => {
    return (
        <div>
            <components.Option {...props}>
            <div className={classNamesPrefixed({
                'field': true,
                'field--checkbox': true
            })}>
            <label
                    htmlFor={props.data.id}
                    className={classNamesPrefixed({
                        "check--label": true,
                    })}>
                    <span className={classNamesPrefixed({
                        "check": true,
                        "check--checked": props.isSelected,
                    })}/>
                    <input
                        type={"checkbox"}
                        id={props.data.id}
                        name={props.data.id}
                        checked={props.isSelected}
                        onChange={() => null}
                    />
                    <span className={classNamesPrefixed({
                        "check--title": true,
                    })}>
                        {props.label}
                    </span>
                </label>
                </div>
            </components.Option>
        </div>
    );
};

const ValueContainer = ({ children, ...props }) => {
    const selected = props.getValue();
    const content = (length => {
        switch (length) {
            case 0:
                return children;
            case 1:
                return selected[0].title;
            default:
                return `${selected.length} options selected`;
        }
    })(selected.length);
  
    return (
        <components.ValueContainer {...props}>
            {content}
            {React.Children.map(children, (child) => {
                return child.props.id === 'clickableInput' ? child : null;
            })}
        </components.ValueContainer>
    );
}

const SelectField = (props) => {
    let defaultItem = null;
    let items = props.items ? props.items : [];

    const { prefix = 'custom-select', input, clearable, defaultValue, afterOnChange, afterOnChangeObject, placeholder, omitCollapsible, label, expanded, disabled, isMultiple, selecktKey } = props;

    if (input && input.value) {
        const item = _.find(items, {id: input.value});
        if (item) {
            defaultItem = {
                id: item.id,
                title: item.title
            };
        }
    }

    let inputWrapProps = {
        ...props,
        error: props && props.meta && props.meta.error ? props.meta.error : props && props.error ? props.error : false,
        type: "select",

    };

    let onInputChange = input ? input.onChange : null;

    const content = (
        <InputWrap {...inputWrapProps}>
            <Select
                key={selecktKey ? selecktKey : prefix}
                classNamePrefix={classNamesPrefixed({
                    [prefix]: true
                })}
                value={defaultItem ? defaultItem : defaultValue}
                isDisabled={disabled ? disabled : false}
                isLoading={false}
                isClearable={clearable ? clearable : false}
                isRtl={false}
                isSearchable={true}
                options={items}
                components={isMultiple ? { Option, ValueContainer } : { SingleValue }}
                hideSelectedOptions={false}
                closeMenuOnSelect={isMultiple ? false : true}
                getOptionValue={(option) => (option.id)}
                getOptionLabel={(option) => (option.title)}
                placeholder={placeholder}
                isMulti={isMultiple ? isMultiple : false}
                inputId={'clickableInput'}
                onChange={(value) => {
                    if (value && value.id) {
                        if (onInputChange) {
                            onInputChange(value.id);
                        }

                        if (afterOnChange) {
                            afterOnChange(value.id);
                        }

                        if (afterOnChangeObject) {
                            afterOnChangeObject(value);
                        }
                    } else {
                        if (isMultiple) {
                            afterOnChange(value);
                        } else {
                            if (onInputChange) {
                                onInputChange(null);
                            }

                            if (afterOnChange) {
                                afterOnChange(null);
                            }

                            if (afterOnChangeObject) {
                                afterOnChangeObject(null);
                            }
                        }
                    }
                    return value;
                }}
            />
        </InputWrap>
    );

    return (
        <Fragment>
            {omitCollapsible ? (
                <Fragment>{content}</Fragment>
            ) : (
                <Collapsible
                    {...collapsibleSettings}
                    trigger={label ? <label className={classNamesPrefixed({"trigger__label":true})}>{label}</label> : ''}
                    open={expanded}
                >
                    {content}
                </Collapsible>
            )}
        </Fragment>
    );
};

export default SelectField;



// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/SelectField.js